// extracted by mini-css-extract-plugin
module.exports = {"faq":"SectionFaq_faq__qXm2K","container":"SectionFaq_container__4uY87","faq__title":"SectionFaq_faq__title__dHXdM","faq__list-container":"SectionFaq_faq__list-container__LuoiE"};